import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import CompanyLogo from "@/components/CompanyLogo";
import { ArrowRight } from "@phosphor-icons/react";

export default function Companies() {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/companies").then((r) => setCompanies(r.data)).finally(() => setLoading(false));
    }, []);

    return (
        <div className="p-8 lg:p-10 max-w-[1400px]" data-testid="companies-page">
            <div className="mb-8">
                <div className="overline mb-2">Portfolio</div>
                <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tighter leading-none">COMPANIES</h1>
                <p className="text-sm text-muted2 mt-2 max-w-xl">Five operating units across logistics, agro-processing, agriculture, manufacturing and drilling.</p>
            </div>
            {loading ? (
                <div className="overline">Loading…</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {companies.map((c) => (
                        <Link key={c.id} to={`/companies/${c.slug}`} data-testid={`company-tile-${c.slug}`}
                            className="grid-card grid-card-hover p-6 group flex gap-4 items-start">
                            <CompanyLogo company={c} size="lg" />
                            <div className="flex-1 min-w-0">
                                <div className="overline mb-1">{c.sector}</div>
                                <div className="font-heading text-2xl font-bold tracking-tight leading-tight">{c.name}</div>
                                <div className="text-sm text-muted2 mt-1">{c.tagline}</div>
                            </div>
                            <ArrowRight size={20} className="shrink-0 mt-2 group-hover:translate-x-1 transition-transform" />
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
